"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _Icon = require("../Icon");

var EmbedVideoTip = function EmbedVideoTip(_ref) {
  var _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {} : _ref$classes,
      wrapperProps = (0, _objectWithoutProperties2["default"])(_ref, ["classes"]);
  return /*#__PURE__*/_react["default"].createElement(_material.Box, wrapperProps, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    icon: "graduation-cap",
    color: "default-light"
  }), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: classes.textBlockClass,
    pl: 2
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: "Subcopy-Static Alt"
  }, "The supported video services and formats are listed below:", /*#__PURE__*/_react["default"].createElement(_material.Box, null, "For more information, please read the\xA0", /*#__PURE__*/_react["default"].createElement("a", {
    className: "Subcopy-Regular-Link",
    target: "_blank",
    rel: "noreferrer noopener",
    href: "https://help.alyce.com/article/192-how-to-embed-a-video-link-into-an-alyce-campaign-landing-page"
  }, "Alyce support article."))), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    pt: 1,
    fontFamily: "Lato",
    fontSize: 12,
    color: "grey.main"
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, null, /*#__PURE__*/_react["default"].createElement("b", null, "\u2022 Youtube format:"), " https://www.youtube.com/embed/*"), /*#__PURE__*/_react["default"].createElement(_material.Box, null, /*#__PURE__*/_react["default"].createElement("b", null, "\u2022 Wistia format:"), " https://fast.wistia.net/embed/* or https://fast.wistia.com/embed/*"), /*#__PURE__*/_react["default"].createElement(_material.Box, null, /*#__PURE__*/_react["default"].createElement("b", null, "\u2022 Vidyard format:"), " https://play.vidyard.com/*"), /*#__PURE__*/_react["default"].createElement(_material.Box, null, /*#__PURE__*/_react["default"].createElement("b", null, "\u2022 Vimeo format:"), " https://player.vimeo.com/*"))));
};

var _default = /*#__PURE__*/(0, _react.memo)(EmbedVideoTip);

exports["default"] = _default;